import {useObserver} from "mobx-react-lite";
import React, {useContext, useEffect, useState} from 'react';
import {Route, Switch, Redirect} from "react-router-dom";
import {ExceedApiContext} from "../App/ExceedApi";
import Tasks from './../../components/Tasks/Tasks';
import SwitchProject from './../../components/SwitchProject';
import "./main.css"

const Main = () => {
    const ExceedApi = useContext(ExceedApiContext);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const asyncDidMount = async () => {
            await ExceedApi.loadInitialData();
            setLoaded(true);
        }
        asyncDidMount();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useObserver(() => {
            if (!loaded) return null;

            return <Switch>
                <Route path="/tasks" name="Tasks" component={() => <Tasks/>}/>
                <Route path="/switchProject" name="SwitchProject" component={() => <SwitchProject/>}/>
                <Redirect from="/" to="/tasks"/>
            </Switch>
        }
    );
};
export default Main;